<script setup lang="ts">
import { useQuasar } from 'quasar';
import SchoolForgotPasswordView from 'src/modules/School/views/SchoolForgotPasswordView/SchoolForgotPasswordView.vue';
import FlashAuthPageDecoration from 'src/shared/components/FlashAuthPageDecoration/FlashAuthPageDecoration.vue';

const $q = useQuasar();
$q.dark.set(false);
</script>

<template>
  <q-page
    padding
    class="column bg-primary"
  >
    <SchoolForgotPasswordView
      class="column fit items-center justify-center relative"
    />
    <FlashAuthPageDecoration v-if="!$q.platform.is.mobile" />
  </q-page>
</template>
